export enum Recurrence {
  Monday = 1,
  Tuesday,
  Wednesday,
  Thursday,
  Friday
}
